import React, { useState } from "react";
import "./GenixPendant.css";

const TryGenixPendant = () => {
  const [joined, setJoined] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setJoined(true);
  };

  return (
    <section className="pendant-section" style={{ height: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="pendant-container fortry" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 48,position:"relative",bottom:"50px" }}>
        {/* Left: Waitlist Form or Success Message */}
        <div className="pendant-content" style={{
          flex: 1,
          minWidth: 320,
          background: "#fff",
          borderRadius: 24,
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          padding: 40,
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}>
          {!joined ? (
            <>
              <img src="/images/GenixLogo.png" alt="Genix Logo" style={{ width: 120, marginBottom: 24,position:"relative",bottom:"24px",right:"171px"}} />
              <h2 style={{ fontWeight: 700, fontSize: 20, textAlign: "center", marginBottom: 8,color:"black" }}>
                Join the <span style={{ color: "#0098d0", textDecoration: "underline" }}>Genix Pendant</span> Waitlist
              </h2>
              <p style={{ color: "#64748b", marginBottom: 24, textAlign: "center" }}>
                Be the First to Experience the Genix Pendant
              </p>
              <form onSubmit={handleSubmit} style={{ display: "flex", gap: 12, width: "100%", marginBottom: 24,height :"56px" }}>
                <input
                  type="email"
                  placeholder="E-mail address"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={{
                    flex: 1,
                    padding: "14px 18px",
                    borderRadius: 8,
                    border: "none",
                    background: "#f1f5f9",
                    fontSize: 16,
                    outline: "none"
                  }}
                />
                <button
                  type="submit"
                  style={{
                    padding: "14px 28px",
                    borderRadius: 8,
                    border: "none",
                    background: "#0098d0",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: "pointer"
                  }}
                >
                  Join Waitlist
                </button>
              </form>
              <div style={{ display: "flex", alignItems: "center", marginBottom: 32 }}>
                <img src="https://tse1.mm.bing.net/th?id=OIP.ukGu51R5DYdW8uYRpPdAfAHaEK&pid=Api&P=0&h=180" alt="Avatars" style={{ width: 80, marginRight: 1,borderRadius : 10 }} />
                <span style={{ color: "#64748b", fontSize: 15 }}>
                  Join 100+ early adopters already on the waitlist.
                </span>
              </div>
              <div style={{ marginTop: 16, textAlign: "center" }}>
                <div style={{ color: "#222", fontWeight: 500, marginBottom: 8 }}>Follow us</div>
                <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36, height: 36, borderRadius: "50%", background: "#0077b5", color: "white" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  <a href="https://x.com" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36, height: 36, borderRadius: "50%", background: "#000000", color: "white" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </>
          ) : (
            <>
              <img src="/images/GenixLogo.png" alt="Genix Logo" style={{ width: 120, marginBottom: 24,position:"relative",bottom:"24px",right:"171px"}} />
              <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 0 }}>
                <div style={{ background: "#e6f7fb", borderRadius: "50%", width: 70, height: 70, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24 }}>
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#e6f7fb"/><path d="M28.5 15.5L18 26L12.5 20.5" stroke="#00b6e6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <h2 style={{ fontWeight: 700, fontSize: 22, textAlign: "center", marginBottom: 8, color: "#222" }}>
                  Thanks for joining the <span style={{ color: "#0098d0", textDecoration: "underline" }}>waitlist!</span>
                </h2>
                <p style={{ color: "#64748b", marginBottom: 16, textAlign: "center", fontSize: 15 }}>
                  You've successfully joined the Genix Pendant waitlist. We'll notify you as soon as it's ready for early access.
                </p>
                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 16 }}>
                  <div style={{ width: "100%", borderBottom: "2px solid #e6f7fb", margin: "12px 0 8px 0" }}></div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                    <img src="https://tse1.mm.bing.net/th?id=OIP.ukGu51R5DYdW8uYRpPdAfAHaEK&pid=Api&P=0&h=180" alt="Avatars" style={{ width: 32, borderRadius: 8 }} />
                    <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Avatars" style={{ width: 32, borderRadius: 8 }} />
                    <img src="https://randomuser.me/api/portraits/men/45.jpg" alt="Avatars" style={{ width: 32, borderRadius: 8 }} />
                    <img src="https://randomuser.me/api/portraits/women/46.jpg" alt="Avatars" style={{ width: 32, borderRadius: 8 }} />
                  </div>
                  <span style={{ color: "#64748b", fontSize: 14, textAlign: "center" }}>
                    You're not alone, 100+ people joined.
                  </span>
                </div>
                <button style={{ background: "#00b6e6", color: "#fff", border: "none", borderRadius: 8, padding: "14px 40px", fontWeight: 600, fontSize: 18, margin: "16px 0 24px 0", cursor: "pointer" }} onClick={() => window.location.href = "/"}>
                  Home
                </button>
                <div style={{ marginTop: 8, textAlign: "center" }}>
                  <div style={{ color: "#222", fontWeight: 500, marginBottom: 8 }}>Follow us</div>
                  <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "8px", background: "#e6f7fb", color: "#222", border: "1px solid #e6f7fb", marginRight: 8 }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <rect width="24" height="24" rx="4" fill="#e6f7fb"/>
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </a>
                    <a href="https://x.com" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "8px", background: "#e6f7fb", color: "#222", border: "1px solid #e6f7fb" }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <rect width="24" height="24" rx="4" fill="#e6f7fb"/>
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/* Right: Image */}
        <div className="pendant-image" style={{ flex: 1, minWidth: 320, display: "flex", justifyContent: "center",boxShadow:"none"}}>
          <img
            src="/images/tryPendent.png"
            alt="Try Genix Pendant"
            className="pendant-photo"
            style={{ maxWidth: 400}}
          />
        </div>
      </div>
    </section>
  );
};

export default TryGenixPendant; 